import { QUALITY, IMAGES } from "@/lib/data";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/i18n";
import { ShieldCheck } from "lucide-react";

/** Four quality pillars with an export-logistics image. */
const QualityGrid = () => {
  const { t, data } = useLang();

  return (
    <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal><Overline>{t("qualityGrid.overline")}</Overline></Reveal>
          <Reveal delay={0.05}>
            <p className="mt-6 text-[#5f6b57] text-base md:text-lg leading-relaxed max-w-md">
              {t("qualityGrid.para")}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative mt-10 overflow-hidden rounded-2xl border border-[#1d3a1f]/10 card-soft group">
              <img src={IMAGES.shipping} alt="Container ship at an export port loading graded fruit for international markets" loading="lazy" className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d1f12]/85 via-[#0d1f12]/20 to-transparent" />
              <span className="absolute bottom-4 start-4 text-xs font-bold tracking-[0.2em] uppercase text-[#e7c46b]">{t("qualityGrid.badge")}</span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {QUALITY.map((q, i) => {
            const dq = data.quality?.[i];
            return (
              <Reveal key={q.title} delay={i * 0.07}>
                <div data-testid={`quality-card-${i}`} className="h-full bg-[#ffffff] rounded-2xl border border-[#1d3a1f]/10 card-soft hover:border-[#d3a53a] hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300 p-7">
                  <ShieldCheck className="text-[#d3a53a]" size={28} />
                  <h3 className="mt-5 font-display font-bold text-xl">{dq?.title || q.title}</h3>
                  <p className="mt-3 text-[#5f6b57] leading-relaxed">{dq?.desc || q.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default QualityGrid;
